var render = function render(){var _vm=this,_c=_vm._self._c;return _c('item-list-component',{attrs:{"item-type":'openUser',"member-key":_vm.memberKey}})
}
var staticRenderFns = []

export { render, staticRenderFns }